
import { defineComponent, inject, ref, reactive, onMounted, watch } from "vue";
import {
    getOrderTable,
    giveOutVipCard,
    giveOutProject,
    orderServiceList,
    permissionList,
    postOrderWriteOff,
    getConstructors
} from "@/api/http";
import { column } from "@/assets/types/common";
import { validateInput } from "@/assets/js/formRules";

type screen = {
    search: string;
    time: Array<string> | null;
    service: Array<number> | null;
};
type screenKey = keyof screen;
type order = {
    ordersn: string;
    create_time: string;
    project: string;
    classifcation: string;
    goodsprice: string;
    user_id: string;
    phone: number | null;
    pay_status_text: string;
    nucleus_pin_code: string;
    nucleus_pin_code_status: number;
    id: number;
};
const columnList: Array<column> = [
    {
        prop: "ordersn",
        label: "订单编号",
        width: 180,
    },
    {
        prop: "create_time",
        label: "下单时间",
        width: 164,
    },
    {
        prop: "project_name",
        label: "服务项目",
        width: 80,
    },
    {
        prop: "project_type_name",
        label: "服务分类",
        width: 80,
    },
    {
        prop: "goodsprice",
        label: "售价",
        width: 80,
    },
    {
        prop: "user_id",
        label: "会员号",
        width: 80,
    },
    {
        prop: "phone",
        label: "手机号",
        width: 120,
    },
    {
        prop: "pay_status_text",
        label: "订单状态",
        width: 80,
    },
];
const orderStatusNav: Array<{ name: string; id: number | string }> = [
    {
        name: "全部订单",
        id: "",
    },
    {
        name: "待付款",
        id: 0,
    },
    {
        name: "待核销",
        id: 1,
    },
    {
        name: "已完成",
        id: 2,
    },
    {
        name: "售后",
        id: 3,
    },
];
import { ElMessageBox } from "element-plus";
import { Request } from "@/api/request";
import {data} from "cheerio/lib/api/attributes";
export default defineComponent({
    name: "orderService",
    setup() {
        const setTitle: any = inject("setTitle");
        setTitle(["服务订单"]);
        const headClass = inject("headClass");
        let pageSize = ref(10),
            currentPage = ref(1),
            tableData = ref([] as Array<order>),
            detailTable = ref([] as Array<any>),
            branchList = ref([]),
            total = ref(0),
            roleList = ref({} as any),
            loading = ref(true),
            dialog_show = ref(false),
            screen = ref({
                search: "",
                time: null,
                service: null,
            } as screen),
            orderStatus = ref(0),
            screenParameter: any = {
                page: currentPage.value,
                pagesize: pageSize.value,
                status: orderStatusNav[orderStatus.value].id,
            },
            shortcuts = ref([
                {
                    text: "最近一周",
                    value: (() => {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        return [start, end];
                    })(),
                },
                {
                    text: "最近一个月",
                    value: (() => {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        return [start, end];
                    })(),
                },
                {
                    text: "最近三个月",
                    value: (() => {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        return [start, end];
                    })(),
                },
            ]),
            project = ref([]),
            dialogFormVisible = ref(false),
            orderDetail = ref({} as order),
            dialogNavIndex = ref(0),
            rules = reactive({
                name: [
                    {
                        required: true,
                        validator: (
                            rule: any,
                            value: string,
                            callback: Function
                        ) => {
                            validateInput("请输入核销码", value, callback);
                        },
                        trigger: "change",
                    },
                ],
            }),
            formRef = ref(null),
            projectForm = reactive({
                phone:"",
                project_id:"",
                number:"",
                cost_price:"",
                branch_id:""
            }),
            projectList = ref([]),
            projectRules = reactive({
                phone: [
                    {
                        required: true,
                        validator: (
                            rule: any,
                            value: string,
                            callback: Function
                        ) => {
                            validateInput("请输入手机号", value, callback);
                        },
                        trigger: "change",
                    },
                ],
                project_id: [
                    {
                        required: true,
                        validator: (
                            rule: any,
                            value: string,
                            callback: Function
                        ) => {
                            validateInput("请选择项目", value, callback);
                        },
                        trigger: "change",
                    },
                ],
                number: [
                    {
                        required: true,
                        validator: (
                            rule: any,
                            value: string,
                            callback: Function
                        ) => {
                            validateInput("该项必填", value, callback);
                        },
                        trigger: "change",
                    },
                ],
            }),
        projectFormRef = ref(null);

        let getTableData = () => {
                loading.value = true;
                let mydata = {
                    type:1,
                    role_name:'order_service',
                };
                permissionList(mydata).then((res:any)=>{
                    roleList.value = res?.content?.list || 0;
                });
                getOrderTable({
                    ...screenParameter,
                    page: currentPage.value,
                    pagesize: pageSize.value,
                }).then((res: any) => {
                    tableData.value = res?.content?.list || [];
                    loading.value = false;
                    total.value = res?.content?.total || 0;
                });
            },
            handleSizeChange = (size: number): void => {
                pageSize.value = size;
                getTableData();
            },
            handleCurrentChange = (page: number): void => {
                currentPage.value = page;
                getTableData();
            },
            // 提交事件
            _formSubmit = ()=> {
                giveOutProject({...projectForm}).then((res:any)=>{
                    if (res.status == 202) {
                        dialog_show.value = false;
                        getTableData();
                    }
                });
            },
            addCard = () => {
            if (projectFormRef.value){
                (projectFormRef.value as any).resetFields();
            }
                dialog_show.value = true;
                Request.axiosInstance({
                    url: 'adminapi/Project/list',
                    data: {
                        pagesize:200,
                        page:1
                    }
                }).then((res: any) => {
                    projectList.value = res?.content?.list || [];
                });
                console.log('11')
            },
            screenChange = (
                e: string | Array<Date> | Array<number>,
                key: screenKey
            ): void => {
                if (!e) {
                    if (key == "service") {
                        delete screenParameter["project_type_pid"];
                        delete screenParameter["project_id"];
                    } else if (key == "time") {
                        delete screenParameter["start_time"];
                        delete screenParameter["end_time"];
                    } else {
                        delete screenParameter[key];
                    }
                } else {
                    if (key == "service") {
                        screenParameter["project_type_pid"] = e[0];
                        screenParameter["project_id"] = e[1];
                    } else if (key == "time") {
                        screenParameter["start_time"] =
                            (e[0] as Date).getTime() / 1000;
                        screenParameter["end_time"] =
                            (e[1] as Date).getTime() / 1000;
                    } else {
                        screenParameter[key] = e;
                    }
                }
                getTableData();
            },
            columnChange = (item: any, index: number) => {
                if (index > 1) {
                    let callBack = (status:number) => {
                        Request.axiosInstance({
                            url: "adminapi/Order/orderRefund",
                            data: {
                                order_id: item.id,
                                status
                            },
                        });
                    };
                    ElMessageBox.confirm(
                        index == 2
                            ? "如线下退款则点击标记退款，线上退款则点击确认退款"
                            : "是否拒绝退款？",
                        index == 2 ? "是否同意退款？" : "提示",
                        {
                            confirmButtonText: index == 2 ? "确认退款" : "确定",
                            cancelButtonText:
                                index == 2 ? "标记已退款" : "取消",
                            type: "warning",
                            cancelButtonClass: "cancel-button-class",
                            confirmButtonClass: "confirm-button-class",
                        }
                    )
                        .then(() => {
                            callBack(index)
                        })
                        .catch(() => {
                            if (index == 2) {
                                callBack(1)
                            }
                        });
                } else {
                    dialogFormVisible.value = true;
					let arr = [[
						'订单编号',
						item.ordersn,
						'下单时间',
						item.create_time,
						'服务项目',
						item.project_name,
						'服务分类',
						item.project_type_name,
					],[
						'售价',
						item.goodsprice,
						'会员号',
						item.user_id,
						'会员手机',
						item.phone,
						'订单状态',
						item.pay_status_text,
					]];
					orderDetail.value = item;
					detailTable.value = arr;
                    dialogNavIndex.value = index;
                }
            },
            check = (): void => {
                (formRef.value as any).validate((valid: boolean) => {
                    console.log(valid);
                    if (valid) {
                        postOrderWriteOff({
                            order_id: orderDetail.value.id,
                            nucleus_pin_code:
                                orderDetail.value.nucleus_pin_code,
                        }).then((res) => {
                            if (res.status == 202) {
                                orderDetail.value.pay_status_text = "已完成";
                                orderDetail.value.nucleus_pin_code_status = 1;
                                getTableData();
                            }
                        });
                    }
                });
            };
        onMounted(() => {
            getTableData();
            orderServiceList({}).then((res: any) => {
                project.value = res?.content || [];
            });
            getConstructors({type:1}).then((res:any)=>{
                console.log(res.content);
                branchList.value = res.content;
            });
        });
        watch(orderStatus, (newValue, oldValue) => {
            screenParameter.status = orderStatusNav[newValue].id;
            getTableData();
        });
        return {
            headClass,
            columnList,
            pageSize,
            currentPage,
            tableData,
            detailTable,
            total,
            loading,
            orderStatusNav,
            orderStatus,
            screen,
            shortcuts,
            project,
            dialogFormVisible,
            orderDetail,
            dialogNavIndex,
            rules,
            formRef,
            handleSizeChange,
            handleCurrentChange,
            screenChange,
            columnChange,
            check,
            roleList,
            addCard,
            projectFormRef,
            projectForm,
            projectRules,
            dialog_show,
            projectList,
            _formSubmit,
            branchList
        };
    },
    mounted() {},
    methods: {
        a() {
            // (this.print as any).click()
            //  (this as any).$print(this.print)
        },
    },
});
